exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".type[data-v-dbbdd742]{list-style:none}.type .type-head[data-v-dbbdd742]{padding-right:20px}.type .type-head ul[data-v-dbbdd742]{width:100%;padding-left:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.type .type-head ul li[data-v-dbbdd742]{margin-left:20px}.type .function-icon img[data-v-dbbdd742]{cursor:pointer;width:14px}\n", ""]);

// exports
